import React from 'react';
import { connect } from 'react-redux';
import { Row, Columns } from 'views/Grid';
import InfoBlock from './InfoBlock';
import ActionBar from './ActionBar';
import AddToCartBlock from './AddToCartBlock';
import classnames from 'classnames';
import root from 'window-or-global';
import AddToCartButton from 'AddToCartButton';
import Rupee from 'views/Rupee';
import { Form } from 'views/FormComponents';
import { trackClickedPaymentButton } from 'analytics/track';
import getAmountAnalytics from 'cart/analytics/getAmountAnalytics';
import {
  handleAddToCart,
} from 'actions/CartActions';

import {
  handleValidateAddToCart,
} from '../../actions/ProductActions';

import {
  EVENT,
} from 'config/ProductTypes';

import {
  getOfferTitle,
  getIsOfferAvailable,
  getOfferMinPrice,
  getOfferMaxPrice,
  getOfferDiscount,
  getOfferPriceBoost,
  getOfferDescription,
  getIsImagePortrait,
  getImagePreview,
  getOfferType,
  getIsCartable,
  getIsDirectCartable,
  getOfferSlug,
  getIsProductCarted,
  getIsProductBeingCarted,
  getAddToCartErrors,
  getCartedAmount,
  getCartedAmountFormatted,
  getLimitQuantity,
  getPurchasedQuantity,
} from '../../reducers/ProductReducers';

import {
  getOfferPriceLabel,
  getPurchaseButtonLabel,
} from 'utils/labelUtils';

const OfferButton = (props) => {
  const { children, ...others } = props;
  return (
    <button
      className="btn-green btn-block caps"
      {...others}
    >
    {children}
    </button>
  );
};

const OfferContainer = ({
  title,
  priceBoost,
  minPrice,
  maxPrice,
  totalAmount,
  discount: { discountAmount: discount },
  isImagePortrait,
  isOfferAvailable,
  preview,
  offerType,
  isCarted,
  isBeingCarted,
  isCartable,
  isDirectCartable,
  slug,
  limitQuantity,
  purchasedQuantity,
  ...props
}) => {
  const offerContainerClassname = classnames('offer-container', {
    'offer-container--landscape' : !isImagePortrait,
  });
  const buttonContainerClassname = classnames('small-12', {
    'medium-6': !isImagePortrait && preview,
  });
  const availableQuantity = limitQuantity - purchasedQuantity;
  return (
    <div className={offerContainerClassname}>

      <h3 className="font-rc product-title text-word-wrap-break-word">
        {title}
      </h3>

      <ActionBar />

      <div className="offer__info-block">
        <InfoBlock />
        { isOfferAvailable && isCartable && !isDirectCartable ?
          <div className="push-one-half--top">
            <AddToCartBlock />
          </div> :
          null
        }
      </div>

      <div className="offer__pricing-block">
        <div className="offer__pricing-block__price soft--top">
        { isCartable &&
          props.totalAmountFormatted &&
          totalAmount >= minPrice ?
          <span><Rupee value={props.totalAmountFormatted} /></span> :
          getOfferPriceLabel({ priceBoost, minPrice, maxPrice, discount })
        }
        </div>
        { ((offerType === EVENT) && (availableQuantity > 0) && (availableQuantity < 10 || availableQuantity < (limitQuantity * 0.15))) ?
          <div className="text-red soft-quarter--top" style={{ 'fontSize': '12px' }}>
            <svg width="10px" height="12px" viewBox="0 0 10 12" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
              <g id="event-tickets" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="event_ticket_preview" transform="translate(-311.000000, -655.000000)" fillRule="nonzero" fill="#E25465">
                  <g id="Group-22" transform="translate(298.000000, 471.000000)">
                    <g id="Group-14" transform="translate(11.000000, 184.000000)">
                      <g id="fire-(2)" transform="translate(2.000000, 0.000000)">
                        <path d="M2.81237069,11.9850112 C2.04631466,10.3229438 2.45426724,9.3705618 3.04303879,8.4732809 C3.68780172,7.49062921 3.85396552,6.51793258 3.85396552,6.51793258 C3.85396552,6.51793258 4.36081897,7.20496629 4.15806034,8.27950562 C5.05349138,7.24017978 5.22247845,5.58426966 5.08726293,4.95008989 C7.11127155,6.42492135 7.9762931,9.61833708 6.81053879,11.9850112 C13.0108621,8.3271236 8.35282328,2.85379775 7.541875,2.23725843 C7.81219828,2.85377528 7.86346983,3.89748315 7.31739224,4.404 C6.39299569,0.74905618 4.10739224,0 4.10739224,0 C4.37771552,1.8848764 3.12752155,3.94597753 1.92196121,5.48606742 C1.87961207,4.73447191 1.83461207,4.2158427 1.45556034,3.49660674 C1.37047414,4.86195506 0.369762931,5.97492135 0.0987715517,7.34292135 C-0.268297414,9.19550562 0.373728448,10.5519551 2.81237069,11.9850112 Z" id="Shape"></path>
                      </g>
                    </g>
                  </g>
                </g>
              </g>
            </svg>
            <span className="soft-quarter--left">Only {availableQuantity} tickets left.</span>
          </div> : null
        }
        <Row className="soft--top">
          <Columns className={buttonContainerClassname}>
            { !isOfferAvailable ?
              <OfferButton disabled={true}>
                Unavailable
              </OfferButton>
              :
              isCartable ? (
                <Form
                  onSubmit={e => e.preventDefault()}
                  errors={props.addToCartErrors.All_}>
                  <AddToCartButton
                    isBeingCarted={isBeingCarted}
                    isCarted={isCarted}
                    onClick={() => {
                      const analytics = getAmountAnalytics(totalAmount);
                      if (isDirectCartable) {
                        return props.handleAddToCart({ slug, analytics });
                      }
                      return props.handleValidateAddToCart({ slug, analytics });
                    }}
                  />
                </Form>
              )
              :
              <OfferButton
                onClick={() => {
                  root.isPaymentButtonClicked = true;
                  trackClickedPaymentButton({
                    label: getPurchaseButtonLabel({
                      priceBoost, minPrice, offerType,
                    }),
                  });
                }}
              >{
                getPurchaseButtonLabel({ priceBoost, minPrice, offerType })
              }</OfferButton>
            }
          </Columns>
        </Row>
      </div>
    </div>
  );
};

const mapStateToProps = ({ product }) => ({
  title: getOfferTitle(product),
  minPrice: getOfferMinPrice(product),
  maxPrice: getOfferMaxPrice(product),
  discount: getOfferDiscount(product),
  priceBoost: getOfferPriceBoost(product),
  description: getOfferDescription(product),
  isImagePortrait: getIsImagePortrait(product),
  isOfferAvailable: getIsOfferAvailable(product),
  preview: getImagePreview(product),
  offerType: getOfferType(product),
  isCarted: getIsProductCarted(product),
  isBeingCarted: getIsProductBeingCarted(product),
  isCartable: getIsCartable(product),
  isDirectCartable: getIsDirectCartable(product),
  slug: getOfferSlug(product),
  totalAmount: getCartedAmount(product),
  totalAmountFormatted: getCartedAmountFormatted(product),
  addToCartErrors: getAddToCartErrors(product),
  limitQuantity: getLimitQuantity(product),
  purchasedQuantity: getPurchasedQuantity(product),
});

export default connect(mapStateToProps, {
  handleAddToCart,
  handleValidateAddToCart,
})(OfferContainer);



// WEBPACK FOOTER //
// ./src/product/views/_layout/OfferContainer.js